import moment from 'moment';

export const durationList = [
  { label: '15 min', value: '15' },
  { label: '30 min', value: '30' },
  { label: '45 min', value: '45' },
  { label: '1hr', value: '60' },
  { label: '1hr 15min', value: '75' },
  { label: '1hr 30min', value: '90' },
  { label: '1hr 45min', value: '105' },
  { label: '2hrs', value: '120' },
];

export const timeZoneList = [
  { label: 'IST', value: 'IST' },
  { label: 'CST', value: 'CST' },
  { label: 'UTC', value: 'UTC' },
  { label: 'EST', value: 'EST' },
  { label: 'MST', value: 'MST' },
  { label: 'PST', value: 'PST' },
];

export const calculateEndTime = (startTime: string, duration: string) => {
  const durationInMinutes = Number(duration);
  // Parse the start time to a moment object
  const startMoment = moment(startTime, 'hh:mm A');

  // Add the duration to the start time
  const endMoment = startMoment.add(durationInMinutes, 'minutes');

  // Format the end time back to AM/PM format
  const endTime = endMoment.format('hh:mm A');

  return endTime;
};
